<template>
	<div class="event-selection">
		<div v-if="resultState === 'loading'" class="loading"></div>
		<div v-else-if="resultState === 'no-events'" class="no-events">No events found</div>
		<ul v-else-if="resultState === 'events'"
			:class="{'with-foot' : checkedEventIds.length > 0}"
			class="events">
			<li
				v-for="event in events"
				v-bind:key="event.entityId">
				<input
					type="checkbox"
					v-model="checkedEventIds"
					:id="event.entityId"
					:value="event.entityId"
					:disabled="eventIsPromotable(event) === false">
				<label
					:for="event.entityId"
					@keydown.down.prevent="go($event, 'down')"
					@keydown.up.prevent="go($event, 'up')"
					class="event">
					<DateSummary
						:startIso="new Date(event.startIso)"
						:endIso="new Date(event.endIso)"
						:isRanged="event.isRanged"/>
					<div class="whatwherecta">
						<div class="whatwhere">
							<div class="what">
								{{ event.name }}
							</div>
							<div class="where">
								{{ event.venueSummary.name }},
								{{ event.venueSummary.town }}
							</div>
						</div>
						<div v-if="eventIsPromotable(event)" class="cta">
							Promote this event
						</div>
						<div v-else class="cta text-dull">
							Too soon
						</div>
					</div>
				</label>
			</li>
		</ul>
		<transition name="meerkat">
			<div v-if="checkedEventIds.length > 0" class="foot">
				<button class="button gradient sunset" @click="addEvents">
					Boost {{checkedEventIds.length}} {{pluralEventLabel}}
				</button>
			</div>
		</transition>
	</div>
</template>

<script>
	import DateSummary from './DateSummary'
	import axios from 'axios'
	import { eventIsPromotable } from '../date-utils';

	export default {
		name: 'event-selection',
		components : {
			DateSummary
		},
		props: [
			'owner',
			'basket',
			'earliestPromotionIso',
			'shortestPromotionWindow',
		],
		data () {
			return {
				events          : [],
				checkedEventIds : [],
				resultState     : 'loading',
			}
		},

		mounted () {
			if (this.owner) {
				this.getOwnerEvents()
			}
		},

		watch : {
			owner() {
				this.getOwnerEvents()
			},

			events(){
				this.events.forEach(event => {
					if (!this.basket.seeds) {
						return
					}

					if (this.basket.seeds.find(seed => seed.entityId === event.entityId)) {
						this.checkedEventIds.push(event.entityId)
					}
				})
			}
		},

		methods : {
			getOwnerEvents() {
				axios.get(this.$baseApiUrl + `/events/${this.owner.entityType}/${this.owner.entityId}`).then( response => {
					this.events      = response.data.data
					this.resultState = 'events'
				})
			},
			addEvents() {
				let seeds = []

				this.checkedEventIds.forEach(id => seeds.push({
					entityType : 'event',
					entityId   : id,
				}))

				this.$emit('add', seeds)
			},
			eventIsPromotable(event) {
			    return eventIsPromotable(event, this.earliestPromotionIso, this.shortestPromotionWindow)
			}
		},

		computed: {
			pluralEventLabel() {
				return this.checkedEventIds.length > 1 ? 'events' : 'event'
			}
		}
	}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/var';

$foot-height : 75px ;

ul.events {

	li {
		border-bottom : solid 1px $color-ents24-boost-sea-green;

		label {
			display     : flex;
			align-items : center;

			.date-summary {
				margin-right : $gap-default;
			}
		}
	}

	&.with-foot {
		padding-bottom : $foot-height;
	}
}

.foot {
	max-width        : 900px;
	width            : 100%;
    background-color : $color-black;
    border-top       : 2px solid white;
    bottom           : 0;
    display          : flex;
    justify-content  : center;
    min-height       : $foot-height;
    padding          : 1rem;
    position         : fixed;
    z-index          : 10;
}

// e.g. "Events for <strong>Thekla</strong>, Bristol"
.for {
	margin-bottom : $gap-default;

	a {
		color : $color-white;
	}

	button.close {
		width  : 15px;
		height : 15px;
	}
}

[disabled]+label {
	background: $gradient-grey-stripe
}

.whatwherecta {
	flex           : 1;
	flex-direction : column;
	display        : flex;
	padding-top    : 2px; // Align 3 parts w/ calendar



	@media (min-width: 400px) {
		flex-direction: row;
		align-items: center;
	}

	.whatwhere {
		flex : 1;
		margin-right : $gap-default;
	}

	.cta {
		color       : $color-ents24-sunset-salmon;
		margin      : 0;

	}

	.cta, .lowlight-text {
		text-align  : right;
		font-style  : italic;
	}

	.where {
		color : $color-grey-mid;
	}
}

.no-events {
	padding: $gap-large;
}

.help-text {
	margin-top: $gap-large;
}
</style>
